




















































































































































































































































































































































import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import {
  CustomersApi,
  LocationModel,
  PostCustomerRequest,
} from "../../../apis";
import config from "../../../config";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import AddLocationNewCustomer from "./AddLocationNewCustomer.vue";
import { ACTION, ILocation } from "./index";

@Component({
  components: {
    AddLocationNewCustomer,
    MoreVertBtn,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class AdminAddNewCustomer extends Vue {
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  @Ref("observerNewLocation") readonly observerNewLocation!: InstanceType<typeof ValidationObserver>;
  @Ref("observerEditLocation") readonly observerEditLocation!: InstanceType<typeof ValidationObserver>;

  customer = {} as PostCustomerRequest;
  itemsCountry = config.settings.country;
  customerStatus = this.STATUS[0].value;
  locations: LocationModel[] = [];
  selectedLocation: LocationModel = null;
  showLocationDialog = false;
  mode = "";

  get STATUS() {
    return [
      { value: "Active", text: this.$t("locationColumn.status.Active") },
      { value: "Inactive", text: this.$t("locationColumn.status.Inactive") },
    ];
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  get HEADERS() {
    return [
      {
        text: this.$t("locationColumn.locationName"),
        align: "start",
        value: "locationName",
        class: ["tw-p-4"],
      },
      {
        class: ["tw-p-4"],
        text: this.$t("locationColumn.address"),
        value: "address",
      },
      {
        class: ["tw-p-4"],
        text: this.$t("locationColumn.contact"),
        value: "contact",
        cellClass: ["tw-whitespace-pre"],
      },
      { class: ["tw-p-4"], text: this.$t("text.status"), value: "status" },
      {
        class: ["tw-p-4"],
        text: this.$t("locationColumn.action"),
        value: "action",
      },
    ] as DataTableHeader[];
  }

  get ACTIONS(): Array<IAction> {
    return [
      {
        titleName: this.$t("text.edit"),
        action: ACTION.EDIT,
        permission: { context: "CUSTOMER_MANAGEMENT", action: "update" },
      },
    ];
  }

  onSelectedAction({ item }: { item: LocationModel }) {
    this.selectedLocation = item;
    this.mode = "EDIT";
    this.showLocationDialog = true;
  }

  get addCustomerClick() {
    return this.$store.getters.addCustomerClick;
  }

  @Watch("addCustomerClick")
  async onSubmit() {
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    try {
      const body = {
        companyName: this.customer.companyName,
        email: this.customer.email,
        faxNumber: this.customer.faxNumber,
        phoneNumber: this.customer.phoneNumber,
        freeTimes: this.customer.freeTimes,
        treatmentAddress: this.customer.treatmentAddress,
        status: this.customerStatus,
        taxID: this.customer.taxID,
        registrationNo: this.customer.registrationNo,
        locations: this.locations,
        fullAddress: this.locationOption,
      } as PostCustomerRequest;
      const res = await new CustomersApi().addCustomer({
        postCustomerRequest: body,
      });
      this.$router.push({ name: "customer-list" });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  locationOption: Array<ILocation> = [];

  get COUNTRIES() {
    return this.$util.getConfig().settings.country;
  }

  get locationOptionBuilder() {
    const newOptions = this.locationOption.map((opt, index) => {
      return {
        ...opt,
        text: `${opt.address}, ${opt.country}`,
        value: index,
      };
    });
    newOptions.push({
      country: "",
      address: "",
      isPrimary: false,
      text: `+ Add New Address`,
      value: -1,
    });
    return newOptions;
  }

  locationOptionSelected = {};

  showAddAddrForm = false;
  newLocation: ILocation = {};

  showEditAddrForm = false;
  editLocation: ILocation = {};
  backupEditLocation: ILocation = {};

  onEditAddress(item) {
    this.editLocation = item;
    this.backupEditLocation = JSON.parse(JSON.stringify(this.editLocation)) as ILocation;
    this.showEditAddrForm = true;
  }

  onChangeCountry() {
    if ((this.locationOptionSelected as number) === -1) {
      this.newLocation = {};
      this.showAddAddrForm = true;
    } else {
      this.locationOption.map(opt => opt.isPrimary = false);
      const selectedOpt = this.locationOption.find((opt, idx) => idx === this.locationOptionSelected);
      selectedOpt.isPrimary = true;
    }
  }

  async onSubmitAddAdrForm() {
    const isValid = await this.observerNewLocation.validate();
    if (!isValid) return;
    if (this.locationOption.length === 0) {
      this.locationOption.push({...this.newLocation, isPrimary: true});
    } else {
      this.locationOption.push({...this.newLocation, isPrimary: false});
    }
    this.doHideAddAddrForm();
  }

  onCancelAddAdrForm() {
    this.doHideAddAddrForm();
  }

  doHideAddAddrForm() {
    this.showAddAddrForm = false;
    this.newLocation = {};
    this.setLocationOptionSelected();
  }

  async onSubmitEditAdrForm() {
    const isValid = await this.observerEditLocation.validate();
    if (!isValid) return;
    this.locationOption.forEach((location) => {
      if (location.address === this.backupEditLocation.address && location.country === this.backupEditLocation.country) {
        location.address = this.editLocation.address;
        location.country = this.editLocation.country;
        location.isPrimary = this.editLocation.isPrimary;
      }
    });
    this.doHideEditAddrForm();
  }

  onCancelEditAdrForm() {
    this.doHideEditAddrForm();
  }

  doHideEditAddrForm() {
    this.showEditAddrForm = false;
    this.editLocation = {};
    this.setLocationOptionSelected();
  }

  setLocationOptionSelected() {
    this.locationOptionSelected = this.locationOptionBuilder.find(opt => opt.isPrimary === true);
  }

}
